import { Component, Prop } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import MatriculaRegistro from '@/entities/gpln/solicitud/matricula/matricula-registro.vue';
import MatriculaListado from '@/entities/gpln/solicitud/matricula/matricula-listado.vue';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { ParticipacionSnp } from '@/shared/model/snp/alumno.model';

@Component({
  components: {
    'matricula-registro': MatriculaRegistro,
    'matricula-listado': MatriculaListado,
  },
})
export default class MatriculaGplnComponent extends ApeironComponent {
  @Prop({ required: true })
  public readonly solucion: Solucion;

  @Prop({ required: true })
  public readonly solicitud: Solicitud;

  public toggleActualizarTabla = false;
  public mostrarRegistro = false;
  public mostrarListado = true;

  public alumnoEdicion: ParticipacionSnp = new ParticipacionSnp();

  public actualizarTabla(): void {
    this.toggleActualizarTabla = !this.toggleActualizarTabla;
    this.mostrarRegistro = false;
    this.mostrarListado = true;
  }

  public editarAlumno(alumno: ParticipacionSnp): void {
    this.alumnoEdicion = { ...alumno };
    this.mostrarRegistro = true;
    this.mostrarListado = false;
  }
}
